import { ClearFilters } from "Components/Users/ClearFilters";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { communitiesBrandsAction } from "store/filters/reducer.actions";
import { filtersInitialState } from "store/filters/initialState";

export const SelectedBrands: React.FC = () => {
  const dispatch = useDispatch();
  const { communitiesFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );

  const resetFilter = (brand: any) => {
    dispatch(communitiesBrandsAction(brand));
  };

  if (!communitiesFilter.brandIds?.applied) {
    return null;
  }

  return (
    <>
      {communitiesFilter.brandIds.value.map((item: any, index: number) => (
        <div
          key={index}
          className="flex justify-between px-2 max-w-[900px] items-center gap-1 flex-grow-0 flex-shrink-0 relative rounded-lg bg-primary_8"
        >
          <div className="flex justify-center items-center relative px-1 pt-1.5 pb-2">
            <p className="break-all w-full flex-shrink-0 text-sm text-start text-textMid dark:text-inputText capitalize">
              {item.name}
            </p>
          </div>
          <ClearFilters handleClick={() => resetFilter(item)} />
        </div>
      ))}
    </>
  );
};
